import styled from 'styled-components';
import Modal from 'react-modal';
import { zeroPad } from 'react-countdown';
import { connect } from 'react-redux';
import Levels from './Levels';
import GameStatusIndicator from './GameStatusIndicator';
import SecondsCounter from './SecondsCounter';
import images from '../../../images';
import { __ } from '../../../locales';
import clockIcon from '../../../images/Clock.png';

const Container = styled.div`
  visibility: hidden;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  min-height: calc(100vh - 40px - ${Number(window.statusBarHeight || 0)}px);
  margin-top: ${Number(window.statusBarHeight || 0)}px;
`;

const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0px 35px;
`;

const CountDownContainer = styled.div`
  position: fixed;
  display: flex;
  top: 0%;
  right: 6%;
  flex-direction: row;
`;

const TimerImage = styled.img`
  height: 6.66vw;
  width: 6.66vw;
  margin-top: 30%;
  margin-left: 5%;
  scale: 0.7;
`;

const CloseButton = styled.img`
  height: 5vw;
  width: 5vw;
  border-radius: 50%;
  position: fixed;
  top: 2.8%;
  left: 6%;
`;

const TopContainer = styled.div`
  position: fixed;
  display: flex;
  top: 3%;
  justify-content: space-between;
  flex-direction: row;
`;

const ModalImages = styled.div`
  visibility: visible;
  position: fixed;
  display: flex;
  top: 33.33vh;
  right: 12.5vw;
  text-align: center;
  justify-content: space-between;
  flex-direction: column;
`;

const MaterialDetails = styled.div`
  overflow-y: hidden;
  position: fixed;
  width: 85%;
  overflow-x: hidden;
  height: 90.5vh;
  padding: 5px;
  background-color: white;
  background-size: auto 85%;
  background-repeat: no-repeat;
  background-position: center center;
  max-width: 85%;
  max-height: 90.5vh;
  will-change: transform;
  border-radius: 10px;
  box-shadow:
  2px 2px 10px 2px rgba(0, 0, 0, 0.2);
`;

const MaterialImage = styled.img`
  height: 40vh;
  width: 90%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin-left: 5%;
  margin-bottom: 5%;
  max-width: 90%;
  max-height: 90%;
`;

const MaterialName = styled.h2`
  text-align: center;
  font-size: 3.33vh;
  margin-top: 5%;
`;

const ButtonsContainer = styled.div`
  display: flex;
  position: fixed;
  bottom: 1%;
  width: 55%;
  margin-left: auto;
  margin-right: auto;
  transform: translate(40%, -112%);
`;

const HandImage = styled.img`
  position: absolute;
  top: 10%;
  left: 55%;
  transform: ${({ left }) => (left ? 'translate(-55%, -55%) scaleX(-1)' : 'translate(-55%, -55%) scaleX(1)')} ;
  -ms-transform: ${({ left }) => (left ? 'translate(-55%, -55%) scaleX(-1)' : 'translate(-55%, -55%) scaleX(1)')} ;
`;

const OnBoardingText = styled.p`
  color: white;
  margin-left: 10%;
  margin-top: 30%;
  text-align: center;
  font-size: 2.5vh;
  line-height: 1.5em;
`;

const RightArrow = styled.img`
  position: absolute;
  top: 40.33vh;
  left: 65%;
  -ms-transform: translate(-65%, 0%);
  transform: translate(-65%, 0%);
`;

const LeftArrow = styled.img`
  position: absolute;
  top: 40.33vh;
  left: 50%;
  -ms-transform: translate(-65%, 0%);
  transform: translate(-65%, 0%);
`;

/**
 * This component is a modal to on boarding screens for
 * two situation of first or second on boarding screen
 *
 */

const customModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '95%',
    height: '100%',
    borderRadius: 15,
    border: 'none',
    backgroundColor: 'rgba(0,0,0,.0001)'
  }
};

const OnBoardingModal = (
  {
    questionIndex,
    currentLevel,
    modalVisible,
    doneMaterials,
    passedMaterialsCount,
    onClose,
    ButtonState,
    onPressRecycable,
    onPressNotRecycable,
    recycleRightData
  }
) => {
  const modalIsOpen = true;

  const visibilityRecycable = ButtonState === 'firstBoarding' ? 'visible' : 'hidden';
  const visibilityNotRecycable = ButtonState === 'secondBoarding' ? 'visible' : 'hidden';

  const ButtonRecycable = styled.img`
    visibility: ${visibilityRecycable};
    height: 7vh;
    width: 7vh;
    border-radius: 50%;
    background-color: #efefef;
    background-size: contain;
    background-position: center;
    margin: 0 auto;
  `;

  const ButtonNotRecycable = styled.img`
    visibility: ${visibilityNotRecycable};
    height: 7vh;
    width: 7vh;
    border-radius: 50%;
    background-color: #efefef;
    background-size: contain;
    background-position: center;
    margin: 0 auto;
  `;

  const CountDownRectangle = styled.div`
    position: fixed;
    top: ${(Number(window.innerHeight / window.innerWidth) * -1.875 + 6.375)}%;
    right: 4.5%;
    height: 4.5vh;
    width: 20vw;
    background-color: #48802A;
    border-radius: 4vw;
  `;

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={onClose}
      style={customModalStyles}
      overlayClassName="signup-modal-overlay"
    >
      <Container>
        <ModalImages>
          <HandImage
            left={ButtonState === 'secondBoarding'}
            aria-hidden
            alt="Hand image"
            src={images.on_boarding}
          />
          {(ButtonState === 'firstBoarding')
            && (
              <>
                <OnBoardingText>{__('app.please_swipe_right')}</OnBoardingText>
                <RightArrow
                  aria-hidden
                  alt="Right arrow"
                  src={images.on_boarding_arrow}
                />
              </>
            )}
          {(ButtonState === 'secondBoarding')
            && (
              <>
                <OnBoardingText>{__('app.please_swipe_left')}</OnBoardingText>
                <LeftArrow
                  aria-hidden
                  src={images.arrow_left}
                  alt="Left arrow"
                />
              </>
            )}
        </ModalImages>
        <TopContainer>
          <CloseButton role="button" tabIndex={0} src={images.close} alt="Close" />
          <CountDownRectangle />
          <CountDownContainer>
            <SecondsCounter seconds={zeroPad('08')} isBeforeGame={false} />
            <TimerImage
              src={clockIcon}
              alt="Timer"
            />
          </CountDownContainer>
        </TopContainer>
        <Levels
          levels={recycleRightData}
          currentLevel={currentLevel}
          modalVisible={modalVisible}
        />
        <>
          <CardContainer>
            <MaterialDetails>
              <MaterialImage
                src={recycleRightData[currentLevel][questionIndex].mat_image}
                alt={recycleRightData[currentLevel][questionIndex].mat_nm || 'Material image'}
              />
              <MaterialName>
                {recycleRightData[currentLevel][questionIndex].mat_nm}
              </MaterialName>
              <ButtonsContainer>
                <ButtonNotRecycable role="button" tabIndex={0} alt="Not recyclable" src={images.decline} onClick={onPressNotRecycable} />
                <ButtonRecycable role="button" tabIndex={0} alt="Recyclable" src={images.recycable} onClick={onPressRecycable} />
              </ButtonsContainer>
            </MaterialDetails>
          </CardContainer>
          <GameStatusIndicator
            totalMaterials={recycleRightData[currentLevel]}
            doneMaterials={doneMaterials}
            prevTotalMaterials={passedMaterialsCount}
          />
        </>
      </Container>
    </Modal>
  );
};

export default connect(
  (store) => ({
    recycleRightData: store.recycleRight.allRrData
  })
)(OnBoardingModal);
